var _rect, _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChromeExtension(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3727_54369)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#3FAB62"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3727_54369",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0V40H40V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3727_54369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.195 27.9834H17.8845L17.4112 29.2033H16.2785C16.0586 29.2033 15.8802 29.3815 15.8802 29.6017C15.8802 29.8219 16.0586 30 16.2785 30H23.6385C23.8585 30 24.0368 29.8219 24.0368 29.6017C24.0368 29.3815 23.8585 29.2033 23.6385 29.2033H22.5061L22.0325 27.9834H28.722C29.381 27.9834 29.917 27.4474 29.917 26.7884V13.195C29.917 12.536 29.381 12 28.722 12H11.195C10.536 12 10 12.536 10 13.195V26.7884C10 27.4474 10.536 27.9834 11.195 27.9834ZM18.2749 29.1796L18.739 27.9834H21.178L21.6421 29.1796H18.2749ZM10.7967 13.195C10.7967 12.9753 10.9754 12.7967 11.195 12.7967H28.722C28.9416 12.7967 29.1203 12.9753 29.1203 13.195V24.5477H24.7059V22.1573C24.7059 20.7436 23.5558 19.5934 22.142 19.5934H21.0108C20.8561 19.5934 20.7155 19.6828 20.6499 19.8229L19.899 21.4279L19.1766 19.8279C19.112 19.6852 18.97 19.5934 18.8135 19.5934H17.7128C16.299 19.5934 15.1489 20.7436 15.1489 22.1573V24.5477C14.0682 24.5477 11.871 24.5477 10.7967 24.5477V13.195ZM23.9092 22.1573V24.5477H15.9455V22.1573C15.9455 21.1829 16.7383 20.39 17.7128 20.39H18.5563L19.5294 22.5455C19.5936 22.6875 19.7342 22.7789 19.8898 22.7801C19.8908 22.7801 19.8916 22.7801 19.8926 22.7801C20.0472 22.7801 20.1878 22.6906 20.2534 22.5506L21.2642 20.39H22.142C23.1164 20.39 23.9092 21.1829 23.9092 22.1573ZM10.7967 25.3444C16.3879 25.3444 23.5184 25.3444 29.1203 25.3444V26.7884C29.1203 27.0082 28.9416 27.1867 28.722 27.1867C12.9851 27.1867 21.1393 27.1867 11.195 27.1867C10.9754 27.1867 10.7967 27.0082 10.7967 26.7884V25.3444Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9218 26.6658H20.0031C20.2231 26.6658 20.4014 26.4877 20.4014 26.2675C20.4014 26.0473 20.2231 25.8691 20.0031 25.8691H19.9218C19.7018 25.8691 19.5234 26.0473 19.5234 26.2675C19.5234 26.4877 19.7018 26.6658 19.9218 26.6658Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9193 19.0904C21.3635 19.0904 22.4089 17.1275 22.4089 15.8041C22.4089 14.4313 21.2921 13.3145 19.9193 13.3145C18.5465 13.3145 17.4297 14.4313 17.4297 15.8041C17.4297 17.1275 18.4751 19.0904 19.9193 19.0904ZM19.9193 14.1111C20.8527 14.1111 21.6123 14.8705 21.6123 15.8041C21.6123 16.8451 20.7592 18.2937 19.9193 18.2937C19.0795 18.2937 18.2264 16.8451 18.2264 15.8041C18.2264 14.8705 18.9859 14.1111 19.9193 14.1111Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3727_54369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeExtension);
export default __webpack_public_path__ + "static/media/ChromeExtension.cfbef84d360bd67daab4310d212a39bc.svg";
export { ForwardRef as ReactComponent };